const STORAGE_KEY_REQUEST_ID = 'windcreek_booking_request_id';

export function setRequestId(requestId) {
  localStorage.setItem(STORAGE_KEY_REQUEST_ID, requestId);
}

export function getRequestId() {
  return localStorage.getItem(STORAGE_KEY_REQUEST_ID);
}
